import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentTypeConfig;
